import HeaderButton from "./HeaderButton";
import { privateWorkspaceName, teamIconName } from "@app/config/constants";
import posthogEvents from "@app/config/posthog/posthog-events";
import { useSelectedTeam } from "@app/state/store";
import Icon from "@lib/common/components/Icon/Icon";
import promiseDelay from "@lib/common/utils/promiseDelay";
import TeamSwitcher from "@lib/iam/components/TeamSwitcher/TeamSwitcher";
import { Popover, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { usePostHog } from "posthog-js/react";
import { useCallback, useMemo } from "react";

export default function TeamSwitcherButton() {
  const selectedTeam = useSelectedTeam();
  const selectedTeamName = useMemo(() => (selectedTeam ? selectedTeam.name : privateWorkspaceName), [selectedTeam]);
  const isPrivateWorkspace = selectedTeamName == privateWorkspaceName;
  const [opened, popoverControl] = useDisclosure(false);
  const posthog = usePostHog();

  const onTeamSelection = useCallback(async () => {
    await promiseDelay(400); // fake hang time for better UX
    popoverControl.close();
  }, [popoverControl]);

  return (
    <Popover opened={opened} onDismiss={popoverControl.close} width={450} withArrow arrowPosition="center">
      <Popover.Target>
        <Tooltip label="Switch team">
          <HeaderButton
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              event.preventDefault();
              event.stopPropagation();
              posthog.capture(posthogEvents.page_header.team_switcher_button_click);
              popoverControl.toggle();
            }}
            leftSection={
              isPrivateWorkspace ? (
                <Icon name="lock" color="green" variant="solid" />
              ) : (
                <Icon name={teamIconName} variant="light" />
              )
            }
            data-expanded={opened}
          >
            {selectedTeamName}
          </HeaderButton>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <TeamSwitcher onTeamSelection={onTeamSelection} />
      </Popover.Dropdown>
    </Popover>
  );
}
